import projectInfo from './projectInfo'

export const flow = {
    initial: 'projectInfo.projectAddress',
    projectInfo
}